// Importa React y el hook useState desde la librería de React
import React, { useState } from 'react'
// Importa los estilos CSS como un módulo para usar clases CSS de forma modular
import styles from './Contact.module.css'
// Importa EmailJS para envío de emails desde el frontend
import emailjs from '@emailjs/browser'

// Define el componente funcional Contact usando arrow function
const Contact = () => {
  // Declara el estado formData usando useState hook
  const [formData, setFormData] = useState({
    name: '',     // Campo para el nombre
    email: '',    // Campo para el email
    message: ''   // Campo para el mensaje
  })

  // Estado para manejar el loading del botón
  const [isLoading, setIsLoading] = useState(false)

  // Función que maneja los cambios en los inputs del formulario
  const handleChange = (e) => {
    setFormData({
      ...formData,                    // Mantiene todos los valores existentes
      [e.target.name]: e.target.value // Actualiza solo el campo que cambió
    })
  }

  // Función asíncrona que maneja el envío del formulario con EmailJS
  const handleSubmit = async (e) => {
    e.preventDefault() // Previene el comportamiento por defecto del formulario
    setIsLoading(true) // Activa el estado de loading
    
    try {
      // CONFIGURACIÓN DE EMAILJS - REEMPLAZA CON TUS DATOS
      const serviceID = 'service_1zjus0q'        // Reemplaza con tu Service ID
      const templateID = 'template_1kmtn76'      // Reemplaza con tu Template ID
      const publicKey = 'IO6goFD7AQuL2_M6L'        // Reemplaza con tu Public Key
      
      // Parámetros que se enviarán al template
      const templateParams = {
        from_name: formData.name,              // Nombre del remitente
        from_email: formData.email,            // Email del remitente
        message: formData.message,             // Mensaje del formulario
        reply_to: formData.email,              // Email para responder
        to_email: 'Jesus.Sanchez@qslogistics.mx' // Email principal donde llegará el mensaje
      }
      
      // Enviar UN SOLO email (los demás destinatarios se configuran en EmailJS)
      const result = await emailjs.send(
        serviceID,
        templateID,
        templateParams,
        publicKey
      )
      
      console.log('Email enviado exitosamente:', result) // Log de éxito
      alert('¡Mensaje enviado correctamente! Te responderemos pronto.') // Alerta de éxito
      
      // Limpiar formulario después del envío exitoso
      setFormData({
        name: '',
        email: '',
        message: ''
      })
      
    } catch (error) {
      console.error('Error al enviar email:', error)
      
      // Mensaje más específico según el tipo de error
      if (error.status === 400) {
        alert('Error: Verifica que todos los campos estén completos.')
      } else if (error.status === 403) {
        alert('Error: Verifica tu configuración de EmailJS.')
      } else {
        alert('Error al enviar el mensaje. Por favor, intenta de nuevo.')
      }
    } finally {
      setIsLoading(false) // Desactiva el loading sin importar si fue exitoso o falló
    }
  }

  // Retorna el JSX que define la estructura del componente
  return (
    <div id='contact' className={styles.contact}>
      <div className={styles.container}>
        <h2 className={styles.title}>Contacto</h2>

        <form 
          className={styles.form}
          onSubmit={handleSubmit}
        >
          {/* Grupo de input para el nombre */}
          <div className={styles.inputGroup}>
            <label htmlFor='name' className={styles.label}>Nombre</label>
            <input 
              id='name'
              name='name'
              type='text'
              value={formData.name}
              onChange={handleChange}
              className={styles.input}
              placeholder="Tu nombre completo"
              required
            />
          </div>

          {/* Grupo de input para el email */}
          <div className={styles.inputGroup}>
            <label htmlFor='email' className={styles.label}>Email</label>
            <input 
              id='email'
              name='email'
              type='email'
              value={formData.email}
              onChange={handleChange}
              className={styles.input}
              placeholder="tu.email@ejemplo.com"
              required
            />
          </div>

          {/* Grupo de input para el mensaje */}
          <div className={styles.inputGroup}>
            <label htmlFor='message' className={styles.label}>Mensaje</label>
            <textarea 
              id='message'
              name='message'
              value={formData.message}
              onChange={handleChange}
              className={styles.textArea}
              placeholder="Escribe tu mensaje aquí..."
              rows={5}
              required
            />
          </div>

          {/* Botón de envío con estado de loading */}
          <button 
            type="submit" 
            className={styles.submitButton}
            disabled={isLoading} /* Deshabilitado durante el envío */
          >
            {isLoading ? 'Enviando...' : 'Enviar Mensaje'}
          </button>
        </form>
      </div>
    </div>
  )
}

// Exporta el componente como default
export default Contact